/* src/app/components/advertizing-prize/advertizing-prize.component.scss */
/*# sourceMappingURL=advertizing-prize.component.css.map */
